<template>
  <div>
    <b-row>
      <b-col sm="10">
        <b-form-textarea
            id="textarea"
            v-model="newSituation"
            placeholder="Fitness Habits ..."
            rows="1"
            max-rows="3"
        />
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <b-button
                style="margin-top: 25px; background-color:#0fb6fe"
                :disabled="!canGenerate"
                @click="handleGenerateClick"
                block
            >
              Generate
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "Display_PaneEntry",
  components: {},
  created(){},
  mounted() {},
  props: {
    generating: {
      type: Boolean,
      required: true,
      default: false
    },
    settings: {
      type: Object,
      required: false,
      default: () => {}
    },
    userData: {
      type: Object,
      required: false,
      default: () => {}
    },
    isManagementMode: {
      type: Boolean,
      default: false
    },
    myAppSettings_isDisplayActivity: {
      type: Boolean,
      default: false
    },
    myAppSettings_isDisplaySettings: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canGenerate(){
      return this.newSituation && !this.generating ? this.newSituation.length > 0: false;
    }
  },
  methods: {
    handleGenerateClick(){
      if (this.canGenerate){
        this.$emit("generate-click", this.newSituation);
      }
    },
    resetForm() {
        this.newSituation = null;
    }
  },
  data() {
    return {
      newSituation: null
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
